(function () {
  'use strict';

  var cfg = window.CastelbelQtyLimit;
  if (!cfg) return;

  var PROD = 'quantity-selector-component';
  var CART = 'cart-quantity-selector-component';
  var PLUS = '[ref="plusButton"], button[name="plus"], .quantity-plus';
  var INPUT = '[ref="quantityInput"]';

  var cartItems = [];
  var inCartCurrent = 0;
  var cartLoaded = false;
  var observer = null;

  function maxForProduct(id) {
    var f = (cfg.limits || []).filter(function (l) { return l.id === id; })[0];
    if (!f) return null;
    var m = parseInt(f.max, 10);
    return (Number.isFinite(m) && m > 0) ? m : null;
  }
  function productTotal(id) { var t = 0; cartItems.forEach(function (it) { if (it.product_id === id) t += it.quantity; }); return t; }
  function productForVariant(vid) { var it = cartItems.filter(function (i) { return i.variant_id === vid; })[0]; return it ? it.product_id : null; }
  function currentMax() {
    if (!cfg.current) return null;
    var m = parseInt(cfg.current.max, 10);
    return (Number.isFinite(m) && m > 0) ? m : null;
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .catch(function () { return { items: [] }; });
  }

  function shouldBlockIncrease(comp, input) {
    var v = parseInt(input.value, 10) || 0;
    var tag = comp.tagName.toLowerCase();
    if (tag === PROD) {
      var max = currentMax();
      if (max == null) return false;
      var inCart = cartLoaded ? inCartCurrent : (parseInt(input.dataset.cartQuantity, 10) || 0);
      var remaining = Math.max(0, max - inCart);
      return v >= remaining;
    }
    if (tag === CART) {
      var vid = parseInt(comp.getAttribute('data-variant-id'), 10);
      var pid = productForVariant(vid);
      if (pid == null) return false;
      var pmax = maxForProduct(pid);
      if (pmax == null) return false;
      return productTotal(pid) >= pmax;
    }
    return false;
  }

  function patch(name) {
    if (!window.customElements) return;
    customElements.whenDefined(name).then(function () {
      var Cls = customElements.get(name);
      if (!Cls || Cls.prototype.__cbPatched || typeof Cls.prototype.increaseQuantity !== 'function') return;
      var orig = Cls.prototype.increaseQuantity;
      Cls.prototype.increaseQuantity = function () {
        var input = (this.refs && this.refs.quantityInput) || this.querySelector(INPUT);
        if (input && shouldBlockIncrease(this, input)) { safeApply(); return; }
        return orig.apply(this, arguments);
      };
      Cls.prototype.__cbPatched = true;
    });
  }
  patch(PROD);
  patch(CART);

  document.addEventListener('click', function (e) {
    var plus = e.target.closest && e.target.closest(PLUS);
    if (!plus) return;
    var comp = plus.closest(PROD) || plus.closest(CART);
    if (!comp) return;
    var input = comp.querySelector(INPUT);
    if (input && shouldBlockIncrease(comp, input)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  function applyProduct() {
    var max = currentMax();
    if (max == null) return; // produto sem limite: não mexer em nada
    var inCart = cartLoaded ? inCartCurrent : 0;
    var rem = Math.max(0, max - inCart);

    document.querySelectorAll(PROD).forEach(function (comp) {
      var input = comp.querySelector(INPUT);
      var v = 1;
      if (input) {
        v = parseInt(input.value, 10) || 1;
        if (rem > 0 && v > rem) { input.value = String(rem); v = rem; }
      }
      comp.querySelectorAll(PLUS).forEach(function (btn) { btn.disabled = (rem <= 0 || v >= rem); });
    });

    document.querySelectorAll('[ref="addToCart"], button[name="add"], .add-to-cart__button button, .product-form__submit').forEach(function (btn) {
      if (rem <= 0) { btn.setAttribute('disabled', 'disabled'); btn.dataset.cbDisabled = '1'; }
      else if (btn.dataset.cbDisabled === '1') { btn.removeAttribute('disabled'); delete btn.dataset.cbDisabled; }
    });
  }

  function safeApply() {
    if (observer) observer.disconnect();
    applyProduct();
    if (observer) observer.observe(document.body, { childList: true, subtree: true });
  }

  function applyCartBlock() {
    var totals = {};
    cartItems.forEach(function (it) { totals[it.product_id] = (totals[it.product_id] || 0) + it.quantity; });
    var blocked = Object.keys(totals).some(function (pid) {
      var m = maxForProduct(parseInt(pid, 10));
      return m != null && totals[pid] > m;
    });
    document.querySelectorAll('[name="checkout"], button[name="checkout"], .cart__checkout-button, #checkout').forEach(function (btn) {
      if (blocked) { btn.setAttribute('disabled', 'disabled'); btn.dataset.cbDisabled = '1'; }
      else if (btn.dataset.cbDisabled === '1') { btn.removeAttribute('disabled'); delete btn.dataset.cbDisabled; }
    });
  }

  function refresh() {
    getCart().then(function (cart) {
      cartItems = cart.items || [];
      cartLoaded = true;
      inCartCurrent = 0;
      if (cfg.current) cartItems.forEach(function (it) { if (it.product_id === cfg.current.id) inCartCurrent += it.quantity; });
      safeApply();
      applyCartBlock();
    });
  }

  if (cfg.current) {
    var t;
    observer = new MutationObserver(function () { clearTimeout(t); t = setTimeout(safeApply, 120); });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();

  ['cart:updated', 'cart:refresh', 'cart:change', 'cart-drawer:open'].forEach(function (ev) { document.addEventListener(ev, refresh); });
  document.addEventListener('click', function (e) {
    if (e.target.closest('button[name="add"], [ref="addToCart"], .add-to-cart__button button, button[name="minus"], button[name="plus"]')) {
      setTimeout(refresh, 600);
    }
  });
})();